import { render } from "./Jingying.vue?vue&type=template&id=a0bf2528"
import script from "./Jingying.vue?vue&type=script&lang=js"
export * from "./Jingying.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__